import { ScrollView, type ScrollViewProps } from 'react-native';
import { BottomSheetScrollView, useBottomSheetInternal } from '@gorhom/bottom-sheet';

export interface ISheetScrollViewProps extends ScrollViewProps {
  /**
   * When true (default), applies `flex: 1` so the scroll view fills sheet/drawer content area.
   */
  fill?: boolean;
}

/**
 * ScrollView for ContextSheet content: uses Gorhom's `BottomSheetScrollView` when mounted inside a
 * native bottom sheet, otherwise a regular `ScrollView` (drawer, modal, or outside a sheet).
 * Pair with `scrollableContent` and `integratedNativeSheetScrollGestures` on the sheet config.
 */
export function SheetScrollView({ fill = true, style, children, ...rest }: ISheetScrollViewProps) {
  const sheetContext = useBottomSheetInternal(true);
  const resolvedStyle = fill ? [{ flex: 1 }, style] : style;

  if (sheetContext) {
    return (
      <BottomSheetScrollView style={resolvedStyle} {...rest}>
        {children}
      </BottomSheetScrollView>
    );
  }

  return (
    <ScrollView style={resolvedStyle} {...rest}>
      {children}
    </ScrollView>
  );
}
